/* eslint-disable react-refresh/only-export-components */
import { useEffect, useState } from 'react';
import { formatDateTimeInTimeZone } from '@/lib/date-values';

export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

export function fmt(amount: number | undefined | null) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount ?? 0);
}

export function fmtFull(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}

// Pass the document's company tz (`useCompanyTimezone()` / entity timezone) so
// dates don't render in the viewer's browser tz. Omitting it stays browser-local
// (legacy callers) — thread the tz through to fix a surface.
export function formatDate(value?: string | null, timeZone?: string | null): string {
  if (!value) return '—';
  return (
    formatDateTimeInTimeZone(value, timeZone, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    }) || '—'
  );
}

export function formatDateTime(value?: string | null, timeZone?: string | null): string {
  if (!value) return '—';
  return (
    formatDateTimeInTimeZone(value, timeZone, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }) || '—'
  );
}
